module.exports = __webpack_public_path__ + "img/day.7f93fbdb.svg";